import React from 'react'

function Help() {
  return (
    <div className='py-[28px]'>Help</div>
  )
}

export default Help